module.exports = __webpack_public_path__ + "img/small-mob-1.8e977b2f.jpg";